import { addProductCollectionToCart } from "@NA/Overrides/Common/Utilities/CustomTracking";
import { chain } from "@insite/client-framework/Store/Data/Carts/Handlers/AddCartLines"
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import {
    Handler,addToEndOfChain,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { AddCartLinesApiParameter } from "@insite/client-framework/Services/CartService";
import { CartLineCollectionModel } from "@insite/client-framework/Types/ApiModels";

type Parameter = {
    productInfos: ProductInfo[];
} & HasOnSuccess<CartLineCollectionModel>;

type Props = {
    apiParameter: AddCartLinesApiParameter;
    apiResult: CartLineCollectionModel;
};

type HandlerType = Handler<Parameter, Props>;

export const SendTrackingCustom: HandlerType = async props => {
    addProductCollectionToCart(props.apiResult.cartLines, '', props.getState().context.session);
};

addToEndOfChain(chain, SendTrackingCustom);
